import { type SelectDataObject } from '../_tools/inputfields/Select';

const sVertrage: SelectDataObject<{ feld: string; name: string }>[] = [
    { i: [50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60], feld: 'uwe', name: 'UWE-X' },
    { i: 70, feld: 'hp_alt', name: 'Homepage-Tool alt' },
    { i: 80, feld: 'hp_gruppe', name: 'Homepage-Tool Gruppe' },
    { i: 91, feld: 'json', name: 'JSON API' },
    { i: 105, feld: 'hp_kp2', name: 'Homepage-Tool KP2' },
    { i: 150, feld: 'tracking', name: 'Tracking' },
    { i: 152, feld: 'akte', name: 'Akte' },
    { i: 153, feld: 'carscanner', name: 'CarScanner' },
    { i: 155, feld: 'inz', name: 'Inzahlungnahme' },
    { i: 157, feld: 'lead', name: 'Lead-Management' },
    { i: 200, feld: 'individ', name: 'INDIVID' },
];
export default sVertrage;
